// This calls library, will automatically use cached library if found
export const compressImage = (file, options) =>
  import('browser-image-compression').then((imageCompression) =>
    imageCompression.default(file, options),
  );
